import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const initialValues = {
  title: '',
  about_us: ''
};

export const validationSchema = (t: any) =>
  Yup.object().shape({
    title: Yup.string().required(t('Title is required')),
    about_us: Yup.string()
      .test('not-empty-html', t('About us is required'), (value) => {
        if (!value) return false;
        // Remove HTML tags and check if there's content
        const plainText = value.replace(/<[^>]*>?/gm, '').trim();
        return plainText.length > 0;
      })
      .required(t('About us is required'))
  });
